<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <div class="form-group has-label">
            <label class="control-label" v-translate>Logo</label>
            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                          :use-custom-slot="true"
                          v-if="model.logo === null"
                          @vdropzone-file-added="dropzoneFileAdded"
                          @vdropzone-success="dropzoneFileSuccess">
              <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title"><translate>Drag'n'drop the logo in png or jpg format</translate></h3>
                <div class="subtitle"><translate>...or click here and select logo from computer</translate></div>
              </div>
            </vue-dropzone>
          </div>
          <div v-if="model.logo" class="text-center">
            <img :src="model.logoUrl" class="img img-responsive" style="max-width: 200px" alt="">
            <!--        <button v-if="imageSelected && removable" @click.prevent="removeImage" :class="removeButtonClass">{{ strings.remove }}</button>-->
            <!--        <button v-if="imageSelected && toggleAspectRatio && width !== height" @click.prevent="rotateImage" :class="aspectButtonClass">{{ strings.aspect }}</button>-->
            <button v-if="model.logo" @click.prevent="model.logo = null" class="btn btn-warning" v-translate>Change/delete logo</button>
          </div>
        </div>
        <div class="col-md-5 col-sm-12">
          <fg-input  :error="errorMessages.name"
                     :max-length="modelSchema.name.maxLength"
                     :required="modelSchema.name.required"
                     v-model="model.name"
                     :placeholder="'Name' | translate"
                     :label="'Name' | translate"></fg-input>
          <fg-input
            :error="errorMessages.standNumber"
            :max-length="modelSchema.standNumber.maxLength"
            :required="modelSchema.standNumber.required"
            v-model="model.standNumber"
            :placeholder="'Stand number' | translate"
            :label="'Stand number' | translate"></fg-input>
          <!--      <fg-input  :error="errorMessages.uri" @input="inputUri"  :max-length="modelSchema.uri.maxLength" :required="modelSchema.uri.required" v-model="model.uri" :placeholder="'Slug' | translate" :label="'Slug' | translate"></fg-input>-->

          <div class="form-group has-label">
            <label class="control-label" v-translate>Description</label>
            <textarea :max-length="modelSchema.description.maxLength"
                      :required="modelSchema.description.required"
                      v-model="model.description"
                      style="max-height: inherit; resize: vertical;font-size: 12px; line-height: 1.1; min-height: 120px"
                      class="form-control" :placeholder="'Description' | translate"></textarea>
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <label class="control-label" v-translate>Contacts</label>
          <textarea
                    v-model="model.contacts[0].value"
                    style="max-height: inherit; resize: vertical;font-size: 12px; line-height: 1.1; min-height: 270px"
                    class="form-control" :placeholder="'Contacts' | translate"></textarea>
        </div>
      </div>

      <div class="row" v-if="model.id && canEditPermissions">
        <div class="col-md-12">
          <h4 class="card-title"><translate>Permissions</translate></h4>
          <permissions-table v-model="model.permissions" :source="model.source"></permissions-table>
        </div>
<!--        <div class="col-md-6 col-sm-12">-->
<!--          <h4 class="card-title"><translate>Invitations</translate></h4>-->
<!--          <div class="row" v-for="invite in model.invites"><p>{{ invite }}</p></div>-->
<!--        </div>-->

      </div>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import { Card } from 'src/components/UIComponents'
  import moment from 'moment'
  import PictureInput from 'vue-picture-input'
  import {Select, Option, OptionGroup, DatePicker, TimePicker} from 'element-ui'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  // import vueDropzone from 'src/components/Expostat/Components/vueDropzone'

  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import PermissionsTable from '../Components/PermissionsTable'

  export default {
    components: {
      Card,
      PictureInput,
      PermissionsTable,
      vueDropzone: vue2Dropzone,
      [DatePicker.name]: DatePicker,
      [TimePicker.name]: TimePicker,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option
    },
    name: 'StandForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.standId) {
          vm.loadRecord(to.params.standId)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.standId) {
          vm.loadRecord(to.params.standId)
        }
      })
    },
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'stands-index'
        }
      }
    },
    computed: {
      baseApi () {
        return `expostat/event/${this.currentEvent}/stands/`
      },
      ...mapState({
        currentEvent: state => state.events.current,
        currentEventInfo: state => state.events.currentEventInfo,
        // available: state => state.events.available
      }),
      // ...mapGetters({currentEventInfo: 'events/currentEventInfo'}),
      title () {
        if (this.isNew) {
          return this.$gettext('Add stand')
        } else {
          return this.$gettext('Edit stand')
        }
      },
      isNew () {
        return this.model.id === null
      },
      canEditPermissions () {
        return this.$auth.user().isSuperuser
      }
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.standId && !this.model.id) {
        this.loadRecord(this.$route.params.standId)
      }
    },
    data () {
      return {
        dropzoneOptions: {
          url: '/api/filer/image/upload/',
          thumbnailMethod: 'contain',
          acceptedFiles: 'image/*',
          thumbnailWidth: 150,
          thumbnailHeight: 150,
          maxFilesize: 5,
          maxFiles: 1,
          headers: { }
        },
        loading: false,
        errorMessages: {},
        schema: null,
        modelSchema: null,
        logoUrl: null,
        model: {
          id: null,
          logo: null,
          logoUrl: null,
          description: null,
          contacts: [{type: "description", value: null}]
        }
      }
    },
    methods: {
      dropzoneFileAdded (file) {
        // Добавление авторизации к загрузке
        this.dropzoneOptions.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
      },
      dropzoneFileSuccess (file, response) {
        this.model.logo = response.id
        this.model.logoUrl = response.file
      },
      updateModel (model) {
        if (model.contacts === null || model.contacts.length === 0) {
          model.contacts = [{type: "description", value: null}]
        }
        if (model.permissions === undefined) {
          model.permissions = []
        }
        this.model = model
      },
      prepareModelToSave() {
        let model = _.cloneDeep(this.model)
        model.event = this.currentEvent
        if (model.permissions !== undefined) {
          if (this.canEditPermissions) {
            model.permissions.map(e => {
              if (e.user !== null) {
                e.user = e.user.id
              }
              if (e.invite !== null) {
                e.invite = e.invite.id
              }
            })
          } else {
            delete model.permissions
          }
        }
        return model
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.baseApi}${id}/`)
        this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.baseApi, modelToSave) : this.$http.put(`${this.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        await this.save()
        this.$router.go(-1)
      },
      onPictureInput () {
        debugger
      }
    }
  }
</script>

<style scoped>

</style>
